import { AvailableLanguages } from "../states/language-store";

interface TranslationProps {
  [key: string]: {
    [key in AvailableLanguages]: string;
  };
}

export const translations: TranslationProps = {
  sign_in_1: {
    english: "Nickname",
    korean: "닉네임"
  },
  sign_in_2: {
    english: "Enter a nickname",
    korean: "닉네임을 입력하세요"
  },
  sign_in_3: {
    english: "Email",
    korean: "이메일"
  },
  sign_in_4: {
    english: "Enter your email",
    korean: "이메일을 입력하세요"
  },
  sign_in_5: {
    english: "Password",
    korean: "비밀번호"
  },
  sign_in_6: {
    english: "Enter your password",
    korean: "비밀번호를 입력하세요"
  },
  sign_in_7: {
    english: "Forgot password?",
    korean: "비밀번호를 잊으셨나요?"
  },
  sign_in_8: {
    english: "Enter 2-16 characters in alphabets or numbers.",
    korean: "2-16자의 알파벳이나 숫자로 입력하세요."
  },
  sign_in_9: {
    english: "Enter 2-16 characters in alphabets, special characters, or numbers.",
    korean: "2-16자의 알파벳, 특수문자, 숫자로 입력하세요."
  },
  sign_in_10: {
    english: "Confirm Password",
    korean: "비밀번호 확인"
  },
  sign_in_11: {
    english: "Re-enter your password",
    korean: "비밀번호를 다시 입력하세요"
  },
  sign_in_12: {
    english: "Start with Google",
    korean: "구글로 시작하기"
  },
  sign_in_13: {
    english: "Popular",
    korean: "인기"
  },
  sign_in_14: {
    english:
      "Your name and photo will be shown to users who invite you to a workspace via email. By proceeding, you are considered to have understood and agreed to the",
    korean: "귀하의 이름과 사진이 이메일을 통해 워크스페이스로 초대한 사용자에게 표시됩니다. 진행함으로써 귀하는 "
  },
  sign_in_15: {
    english: "Terms of Service",
    korean: "서비스 약관"
  },
  sign_in_16: {
    english: "and",
    korean: "및"
  },
  sign_in_17: {
    english: "Privacy Policy",
    korean: "개인정보 보호정책"
  },
  sign_in_18: {
    english: ".",
    korean: "을 이해하고 동의한 것으로 간주됩니다."
  },
  sign_in_19: {
    english: "Back to sign in",
    korean: "로그인 화면으로 돌아가기"
  },
  sign_in_20: {
    english: "Your own FAQ site\nin under 5 minutes.",
    korean: "5분 안에 나만의\nFAQ 페이지를 만들어보세요."
  },
  sign_in_21: {
    english: "Start SuperFAQ now.",
    korean: "지금 SuperFAQ를 시작하세요."
  },
  sign_in_22: {
    english: "Sign in",
    korean: "로그인"
  },
  sign_in_23: {
    english: "Sign up",
    korean: "회원가입"
  },
  sign_in_24: {
    english: "Send reset password email",
    korean: "비밀번호 재설정 이메일 보내기"
  },
  sign_in_25: {
    english: "Reset password",
    korean: "비밀번호 재설정"
  },
  sign_in_26: {
    english: "Passwords do not match.",
    korean: "비밀번호가 일치하지 않습니다."
  },
  sign_in_27: {
    english: "Password must be at least 6 characters.",
    korean: "비밀번호는 최소 6자 이상이어야 합니다."
  },
  sign_in_28: {
    english: "Sign up successful",
    korean: "회원가입이 완료되었습니다"
  },
  sign_in_29: {
    english: "Welcome to SuperFAQ!",
    korean: "SuperFAQ에 오신 것을 환영해요!"
  },
  sign_in_30: {
    english: "Please enter a valid email address.",
    korean: "유효한 이메일 주소를 입력하세요."
  },
  sign_in_31: {
    english: "Your email is already registered with Google. Please sign in with Google.",
    korean: "이미 구글로 등록된 이메일입니다. 구글로 로그인하세요."
  },
  sign_in_32: {
    english: "An error occurred. Please try again.",
    korean: "오류가 발생했습니다. 다시 시도하세요."
  },
  sign_in_33: {
    english: "Reset password email sent.",
    korean: "비밀번호 재설정 이메일을 보냈어요."
  },
  sign_in_34: {
    english: "Please check your email.",
    korean: "이메일을 확인하세요."
  },
  sign_in_35: {
    english: "Password reset successful",
    korean: "비밀번호 재설정이 완료되었습니다"
  },
  sign_in_36: {
    english: "You can now sign in with your new password.",
    korean: "새로운 비밀번호로 로그인할 수 있습니다."
  },
  sign_in_37: {
    english: "Continue",
    korean: "계속하기"
  },
  mobile_blocker_1: {
    english: "Please open this page on a desktop!",
    korean: "데스크탑으로 접속해주세요!"
  },
  mobile_blocker_2: {
    english: "This page is not optimized for mobile devices.",
    korean: "이 페이지는 모바일 기기에 최적화되어 있지 않습니다."
  },
  mobile_blocker_3: {
    english: "Please open it on a desktop or a tablet for better experiences.",
    korean: "더 나은 사용자 경험을 위해 데스크탑이나 태블릿에서 열어주세요."
  },
  mobile_blocker_4: {
    english: "Close",
    korean: "닫기"
  },
  mobile_blocker_5: {
    english: "Copy Link",
    korean: "링크 복사"
  },
  mobile_blocker_6: {
    english: "Link copied!",
    korean: "링크가 복사되었습니다!"
  },
  mobile_blocker_7: {
    english: "The link has been copied to your clipboard.",
    korean: "링크가 클립보드에 복사되었습니다."
  },
  workspace_1: {
    english: "Create Workspace",
    korean: "워크스페이스 만들기"
  },
  workspace_2: {
    english: "Make your first workspace!",
    korean: "첫 번째 워크스페이스를 만들어보세요!"
  },
  workspace_3: {
    english: "You don't have any workspaces yet.",
    korean: "아직 워크스페이스가 없어요."
  },
  workspace_4: {
    english: "A workspace is where you can manage one FAQ site.",
    korean: "워크스페이스는 하나의 FAQ 페이지를 관리할 수 있는 곳입니다."
  },
  workspace_5: {
    english: "You can make as many workspaces as you want with the free plan.",
    korean: "무료 플랜으로 원하는 만큼 워크스페이스를 만들 수 있어요."
  },
  workspace_6: {
    english: "Manager",
    korean: "매니저"
  },
  workspace_appearance_1: {
    english: "Site name",
    korean: "페이지 이름"
  },
  workspace_appearance_2: {
    english:
      "It will be displayed on the top navigation bar\nand the first page header.\n(Use your company or brand name.)",
    korean: "상단 네비게이션 바와 첫 페이지 헤더에 표시됩니다.\n(회사나 브랜드 이름을 사용하세요.)"
  },
  workspace_appearance_3: {
    english: "Workspace Name",
    korean: "워크스페이스 이름"
  },
  workspace_appearance_4: {
    english: "Brand Logo",
    korean: "브랜드 로고"
  },
  workspace_appearance_5: {
    english: "Brand Color",
    korean: "브랜드 색상"
  },
  workspace_appearance_6: {
    english: "Accepted formats are PNG, JPG, and WEBP.",
    korean: "PNG, JPG, WEBP 형식을 지원합니다."
  },
  workspace_appearance_7: {
    english: "File sizes must be 5MB or less.",
    korean: "파일 크기는 5MB 이하여야 합니다."
  },
  workspace_appearance_8: {
    english: "Logo can be added later.",
    korean: "로고는 나중에 추가할 수 있습니다."
  },
  workspace_appearance_9: {
    english: "Add a color that represents your workspace.",
    korean: "워크스페이스를 대표하는 색상을 추가하세요."
  },
  workspace_appearance_10: {
    english: "Color can be added later.",
    korean: "색상은 나중에 추가할 수 있습니다."
  },
  workspace_appearance_11: {
    english: "Color updated!",
    korean: "색상이 업데이트되었습니다!"
  },
  workspace_appearance_12: {
    english: "Logo updated!",
    korean: "로고가 업데이트되었습니다!"
  },
  workspace_appearance_13: {
    english: "Dashboard",
    korean: "대시보드"
  },
  workspace_appearance_14: {
    english: "Views",
    korean: "조회 수"
  },
  workspace_appearance_15: {
    english: "Category",
    korean: "카테고리"
  },
  workspace_appearance_16: {
    english: "Question",
    korean: "질문"
  },
  workspace_appearance_17: {
    english: "New FAQ",
    korean: "새로운 질문"
  },
  workspace_appearance_18: {
    english: "Make a",
    korean: "새로운"
  },
  workspace_appearance_19: {
    english: " on the left side bar.",
    korean: "을 만들어보세요."
  },
  workspace_appearance_20: {
    english: "You don't have any",
    korean: "아직"
  },
  workspace_appearance_21: {
    english: " yet.",
    korean: " 없어요."
  },
  workspace_appearance_22: {
    english: "category",
    korean: "카테고리"
  },
  workspace_appearance_23: {
    english: "categories",
    korean: "카테고리가"
  },
  workspace_appearance_24: {
    english: "FAQ",
    korean: "질문"
  },
  workspace_appearance_25: {
    english: "FAQs",
    korean: "질문이"
  },
  workspace_appearance_26: {
    english: "You must create a category before creating an FAQ.",
    korean: "FAQ를 만들기 전에 카테고리를 만들어야 합니다."
  },
  workspace_appearance_27: {
    english: "All FAQs must have one category.",
    korean: "모든 FAQ는 하나의 카테고리를 가져야 합니다."
  },
  workspace_appearance_28: {
    english: "You can always change the contents of an FAQ.",
    korean: "FAQ의 내용은 언제든지 변경할 수 있습니다."
  },
  workspace_appearance_29: {
    english: "Tag the right category for your FAQ.",
    korean: "FAQ에 적절한 카테고리를 태그하세요."
  },
  workspace_appearance_30: {
    english: "Question",
    korean: "질문"
  },
  workspace_appearance_31: {
    english: "Category",
    korean: "카테고리"
  },
  workspace_appearance_32: {
    english: "Last updated",
    korean: "마지막 업데이트"
  },
  workspace_appearance_33: {
    english: "Answer",
    korean: "답변"
  },
  workspace_appearance_34: {
    english: "Write your FAQ here...",
    korean: "FAQ를 여기에 작성하세요..."
  },
  workspace_appearance_35: {
    english: "FAQ deleted",
    korean: "FAQ가 삭제되었습니다."
  },
  workspace_appearance_36: {
    english: "FAQ published",
    korean: "FAQ가 게시되었습니다."
  },
  workspace_appearance_37: {
    english: "View applied page",
    korean: "적용된 페이지 보기"
  },
  click_outside_alert_1: {
    english: "Save your work! Your work will not be saved if you leave.",
    korean: "작업을 저장하세요! 나가면 작업이 저장되지 않습니다."
  },
  save: {
    english: "Save",
    korean: "저장"
  },
  delete: {
    english: "Delete",
    korean: "삭제"
  },
  confirm: {
    english: "Confirm",
    korean: "확인"
  },
  copy: {
    english: "Copy",
    korean: "복사"
  },
  manager_delete_toast: {
    english: "Manager Deleted",
    korean: "매니저가 삭제되었습니다."
  },
  manager_table_caption: {
    english: "A list of managers in your workspace.",
    korean: "워크스페이스의 매니저 목록입니다."
  },
  manager_name_column: {
    english: "Name",
    korean: "이름"
  },
  manager_email_column: {
    english: "Email",
    korean: "이메일"
  },
  manager_authority_column: {
    english: "Authority",
    korean: "권한"
  },
  manager_delete_column: {
    english: "Delete Manager?",
    korean: "매니저를 삭제할까요?"
  },
  manager_tab_title: {
    english: "Managers",
    korean: "매니저"
  },
  workspace_tab_title: {
    english: "Workspace",
    korean: "워크스페이스"
  },
  add_manager: {
    english: "Add Manager",
    korean: "매니저 추가"
  },
  add_managers: {
    english: "Add Managers",
    korean: "매니저 추가"
  },
  save_changes: {
    english: "Save changes",
    korean: "변경사항 저장"
  },
  workspace_name_not_match: {
    english: "The workspace name does not match.",
    korean: "워크스페이스 이름이 일치하지 않습니다."
  },
  workspace_deleted: {
    english: "Workspace deleted successfully.",
    korean: "워크스페이스가 성공적으로 삭제되었습니다."
  },
  link_copied: {
    english: "Link copied",
    korean: "링크 복사됨"
  },
  link_copied_description: {
    english: "The link has been copied to your clipboard.",
    korean: "링크가 클립보드에 복사되었습니다."
  },
  shareable_link: {
    english: "Sharable link",
    korean: "공유 가능한 링크"
  },
  workspace_name: {
    english: "Workspace name",
    korean: "워크스페이스 이름"
  },
  delete_page: {
    english: "Delete page",
    korean: "페이지 삭제"
  },
  delete_page_description: {
    english: "To delete your workspace, type the",
    korean: "워크스페이스를 삭제하려면"
  },
  delete_page_description_2: {
    english: "above.",
    korean: "를 입력하세요."
  },
  invite_team_members: {
    english: "Invite team members",
    korean: "팀 멤버 초대"
  },
  invite_team_members_description: {
    english: "You can only invite members who are signed up for SuperFAQ.",
    korean: "SuperFAQ에 가입한 멤버만 초대할 수 있습니다."
  },
  invite_team_members_description_2: {
    english: "If they are not, make sure they sign up for SuperFAQ before you invite them.",
    korean: "가입하지 않은 경우 초대하기 전에 SuperFAQ에 가입하도록 하세요."
  },
  enter_manager_email: {
    english: "Enter manager email",
    korean: "매니저 이메일 입력"
  },
  add: {
    english: "Add",
    korean: "추가"
  },
  no_user_found: {
    english: "No user found",
    korean: "사용자를 찾을 수 없습니다"
  },
  invited_members: {
    english: "Invited members",
    korean: "초대된 멤버"
  },
  invite_more: {
    english: "You can always invite more.",
    korean: "언제든지 더 초대할 수 있습니다."
  },
  remove: {
    english: "Remove",
    korean: "삭제"
  },
  continue: {
    english: "Continue",
    korean: "계속하기"
  },
  skip_for_now: {
    english: "Skip for now",
    korean: "건너뛰기"
  },
  enter_workspace_name: {
    english: "Enter workspace name",
    korean: "워크스페이스 이름 입력"
  },
  can_change_later: {
    english: "You can always change it.",
    korean: "언제든지 변경할 수 있습니다."
  },
  select_plan: {
    english: "Select a plan for your workspace",
    korean: "워크스페이스의 플랜을 선택하세요"
  },
  free_feature_1: {
    english: "Unlimited workspaces",
    korean: "무제한 워크스페이스"
  },
  free_feature_2: {
    english: "Unlimited managers",
    korean: "무제한 매니저"
  },
  free_feature_3: {
    english: "SuperFAQ AI Engine",
    korean: "SuperFAQ AI 엔진"
  },
  free_feature_4: {
    english: "Cannot remove watermark",
    korean: "워터마크 제거 불가"
  },
  free_feature_5: {
    english: "Up to 3 categories",
    korean: "최대 3개 카테고리"
  },
  free_feature_6: {
    english: "Up to 10 FAQs",
    korean: "최대 10개 FAQ"
  },
  plus_feature_1: {
    english: "Unlimited workspaces",
    korean: "무제한 워크스페이스"
  },
  plus_feature_2: {
    english: "Unlimited managers",
    korean: "무제한 매니저"
  },
  plus_feature_3: {
    english: "SuperFAQ AI Engine",
    korean: "SuperFAQ AI 엔진"
  },
  plus_feature_4: {
    english: "Watermark removed",
    korean: "워터마크 제거"
  },
  plus_feature_5: {
    english: "Unlimited categories",
    korean: "무제한 카테고리"
  },
  plus_feature_6: {
    english: "Unlimited FAQs",
    korean: "무제한 FAQ"
  },
  select: {
    english: "Select",
    korean: "선택"
  },
  coming_soon: {
    english: "Coming soon",
    korean: "곧 출시"
  },
  progress_1: {
    english: "Enter workspace name",
    korean: "워크스페이스 이름 입력"
  },
  progress_2: {
    english: "Invite team members",
    korean: "팀 멤버 초대"
  },
  progress_3: {
    english: "Select a plan",
    korean: "플랜 선택"
  },
  updated_profile: {
    english: "Updated your profile!",
    korean: "프로필을 업데이트했습니다!"
  },
  updated_profile_description: {
    english: "Your profile has been successfully updated.",
    korean: "프로필이 성공적으로 업데이트되었습니다."
  },
  delete_account: {
    english: "Deleted your account.",
    korean: "계정을 삭제했습니다."
  },
  delete_account_description: {
    english: "Your account has been successfully deleted.",
    korean: "계정이 성공적으로 삭제되었습니다."
  },
  cannot_change_password: {
    english: "You are using OAuth. You can't change your password.",
    korean: "OAuth를 사용 중입니다. 비밀번호를 변경할 수 없습니다."
  },
  no_email_address: {
    english: "You don't have an email address. You can't change your password.",
    korean: "이메일 주소가 없습니다. 비밀번호를 변경할 수 없습니다."
  },
  check_email: {
    english: "Check your email!",
    korean: "이메일을 확인하세요!"
  },
  check_email_description: {
    english: "We've sent you an email to change your password.",
    korean: "비밀번호를 변경할 수 있는 이메일을 보냈습니다."
  },
  temporary_error: {
    english: "A temporary error occurred. Please try again later.",
    korean: "일시적인 오류가 발생했습니다. 나중에 다시 시도하세요."
  },
  delete_account_button: {
    english: "Delete Account",
    korean: "계정 삭제"
  },
  delete_account_question: {
    english: "Delete your account?",
    korean: "계정을 삭제할까요?"
  },
  change_password: {
    english: "Change Password",
    korean: "비밀번호 변경"
  },
  terms: {
    english: "Terms",
    korean: "약관"
  },
  delete_account_confirmation_1: {
    english: "Are you sure you want to delete your account?",
    korean: "계정을 삭제하시겠습니까?"
  },
  delete_account_confirmation_2: {
    english: "Once you delete your account, there is no going back.",
    korean: "계정을 삭제하면 되돌릴 수 없습니다."
  },
  workspace_left: { english: "Workspace left.", korean: "워크스페이스를 나갔습니다." },
  workspace_left_description: {
    english: "You have successfully left the workspace.",
    korean: "워크스페이스를 성공적으로 나갔습니다."
  },
  workspace_list_caption: {
    english: "A list of your workspaces.",
    korean: "워크스페이스 목록입니다."
  },
  workspace_table_header_1: {
    english: "Workspace",
    korean: "워크스페이스"
  },
  workspace_table_header_2: {
    english: "Authority",
    korean: "권한"
  },
  workspace_table_header_3: {
    english: "Leave",
    korean: "나가기"
  },
  leave_workspace_question: {
    english: "Leave Workspace?",
    korean: "워크스페이스를 나가시겠습니까?"
  },
  add_question: {
    english: "Add Question",
    korean: "질문 추가"
  },
  move_up: {
    english: "Move Up",
    korean: "위로 이동"
  },
  move_down: {
    english: "Move Down",
    korean: "아래로 이동"
  },
  rename: {
    english: "Rename",
    korean: "이름 변경"
  },
  rename_category: {
    english: "Rename category",
    korean: "카테고리 이름 변경"
  },
  delete_faq: {
    english: "Delete FAQ",
    korean: "FAQ 삭제"
  },
  delete_faq_description: {
    english: "Are you sure you want to delete this FAQ?\nThis action cannot be undone.",
    korean: "해당 FAQ를 삭제하시겠습니까?\n이 작업은 되돌릴 수 없습니다."
  },
  faq_deleted: {
    english: "FAQ deleted",
    korean: "FAQ가 삭제되었습니다."
  },
  faq_deleted_description: {
    english: "The FAQ has been successfully deleted.",
    korean: "FAQ가 성공적으로 삭제되었습니다."
  },
  profile: {
    english: "Profile",
    korean: "프로필"
  },
  log_out: {
    english: "Log out",
    korean: "로그아웃"
  },
  my_account: {
    english: "My account",
    korean: "내 계정"
  },
  my_workspaces: {
    english: "My workspaces",
    korean: "내 워크스페이스"
  },
  create_workspace: {
    english: "Create workspace",
    korean: "워크스페이스 만들기"
  },
  invite_description: {
    english: "Users that you want to invite must be registered in SuperFAQ.",
    korean: "초대하려는 사용자는 SuperFAQ에 등록되어 있어야 합니다."
  },
  selected_managers: {
    english: "Selected Managers",
    korean: "선택된 매니저"
  },
  sidebar_appearance_1: {
    english: "Appearance",
    korean: "외관"
  },
  sidebar_appearance_2: {
    english: "Workspace Name",
    korean: "워크스페이스 이름"
  },
  sidebar_appearance_3: {
    english: "Brand Logo",
    korean: "브랜드 로고"
  },
  sidebar_appearance_4: {
    english: "Brand Color",
    korean: "브랜드 색상"
  },
  sidebar_faq_1: {
    english: "FAQ",
    korean: "FAQ"
  },
  sidebar_faq_2: {
    english: "Dashboard",
    korean: "대시보드"
  },
  sidebar_profile_1: {
    english: "My Account",
    korean: "내 계정"
  },
  sidebar_profile_2: {
    english: "Profile",
    korean: "프로필"
  },
  sidebar_profile_3: {
    english: "Workspace",
    korean: "워크스페이스"
  },
  sidebar_settings_1: {
    english: "Settings",
    korean: "설정"
  },
  sidebar_settings_2: {
    english: "Workspace",
    korean: "워크스페이스"
  },
  sidebar_settings_3: {
    english: "Manager",
    korean: "매니저"
  },
  sidebar_workspace_1: {
    english: "My Workspaces",
    korean: "내 워크스페이스"
  },
  sidebar_workspace_2: {
    english: "Search workspace...",
    korean: "워크스페이스 검색..."
  },
  sidebar_workspace_3: {
    english: "Create Workspace",
    korean: "워크스페이스 만들기"
  },
  add_category_button_1: {
    english: "Add Category",
    korean: "카테고리 추가"
  },
  add_category_button_2: {
    english: "Enter the name of the new category",
    korean: "새 카테고리의 이름을 입력하세요"
  },
  add_category_button_3: {
    english: "Category name",
    korean: "카테고리 이름"
  },
  sidebar_bottom_1: {
    english: "Help",
    korean: "도움말"
  },
  sidebar_bottom_2: {
    english: "Log Out",
    korean: "로그아웃"
  },
  workspace_item: {
    english: "Workspace",
    korean: "워크스페이스"
  }
};
